import { ITirPmMultiselectOption } from "tir-components";

/**
 * * Модель опции сотрудника в мультиселекте
 */
export class EmployeeMultiselectOptionModel implements ITirPmMultiselectOption {
  /**ID сотрудника */
  Id!: number;
  /**Цвет аватакри */
  readonly AvatarColor!: string;
  /**Имя */
  readonly FirstName!: string;
  /**Фамилия */
  readonly LastName?: string;
  /**Отчество */
  readonly MiddleName: string;
  /**Аватарка */
  readonly ImageUrl?: string;
  /**Имя и фамилия */
  readonly FirstAndLastName!: string;
  /**Имя и первая буква фамилии */
  readonly FirstNameAndFirstLetterLastName!: string;
  /**Первая буква имени и фамилии */
  readonly FirstNameLetterAndFirstLastNameLetter!: string;

  search = (searchString: string) => {
    return (this.FirstAndLastName?.toLocaleLowerCase() ?? "").includes(
      (searchString ?? "").toLocaleLowerCase(),
    );
  };

  constructor(
    obj?: Omit<
      Partial<EmployeeMultiselectOptionModel>,
      "FirstAndLastName" | "FirstAndFirstLetterLastName"
    >,
  ) {
    Object.assign(this, obj);
    if (obj?.FirstName && obj?.LastName) {
      this.FirstAndLastName = `${obj.FirstName} ${obj.LastName}`;
      this.FirstNameAndFirstLetterLastName = `${obj.FirstName} ${obj.LastName[0]}.`;
      this.FirstNameLetterAndFirstLastNameLetter = `${obj.FirstName[0].toLocaleUpperCase()}${obj.LastName[0].toLocaleUpperCase()}`;
    } else {
      this.FirstAndLastName = obj?.FirstName ?? obj?.LastName ?? "";
      this.FirstNameAndFirstLetterLastName = this.FirstAndLastName;
      this.FirstNameLetterAndFirstLastNameLetter = (obj.FirstName ??
        obj.LastName ??
        "A")[0].toLocaleUpperCase();
    }
  }
}
